import React from "react";
import { Box } from "@mui/material";
import { IconifyIcon, InlineIcon } from "@iconify/react";

interface OcSidebarChevronProps {
  icon: string | IconifyIcon;
  color?: string;
}

export const OcSidebarChevron: React.FC<OcSidebarChevronProps> = ({
  icon,
  color,
}) => {
  const iconSize = "24px";
  return (
    <Box minWidth={iconSize} maxWidth={iconSize} paddingTop="4px">
      <InlineIcon icon={icon} width={iconSize} color={color} />
    </Box>
  );
};

export default OcSidebarChevron;
